/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notif_Mark_All_ReadInputs */

const vi_notif_mark_all_read = /** @type {(inputs: Notif_Mark_All_ReadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đọc tất cả`)
};

/**

* @param {Notif_Mark_All_ReadInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const notif_mark_all_read = /** @type {((inputs?: Notif_Mark_All_ReadInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notif_Mark_All_ReadInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_notif_mark_all_read(inputs)
});